
import { Observable } from './druid/./druid/Observable';
import { bufferTime } from './druid/./druid/operator/bufferTime';

Observable.prototype.bufferTime = bufferTime;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    bufferTime: typeof bufferTime;
  }
}